import React from "react";
import { inject, observer } from "mobx-react";
import TariffsContainer from "./containers/Tariffs";
import ReviewsContainer from "./containers/Reviews";
import RatingTableContainer from "./containers/RatingTableContainer";
import { withRouter } from "react-router-dom";
import HeroBannerContainer from "Containers/HeroBannerContainer";
import WithSeoText from "Layouts/WithSeoText";
import Container from "reactstrap/lib/Container";
import Districts from "Containers/DistrictsContainer";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import TopProviderContainer from "Containers/TopProviderContainer";
import OneClick from "Containers/OneClick";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { generateUrl } from "Services/withDefaultParams";
import { Helmet } from "react-helmet-async";
import configRouters from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";
import { isMainSiteCode } from "Utils/siteConfig";

@withRouter
@inject("ApplicationModel")
@observer
export default class Mainpage extends React.Component {
    canonical() {
        const {
            ApplicationModel: { siteConfig },
        } = this.props;

        const location = generateUrl(
            configRouters.Default.route,
            this.props.match.params
        );

        return (
            <Helmet>
                <link
                    rel="canonical"
                    href={`${siteConfig.ssl === true ? `https` : "http"}://${
                        siteConfig.domain_name_full
                    }${location}`}
                />
            </Helmet>
        );
    }

    componentDidMount() {
        sendMetriks("OPEN_MAIN");
    }

    render() {
        const {
            ApplicationModel: {
                windowSizeModel: { windowSizes },
                text,
                currentRegion,
            },
        } = this.props;
        const { seoData } = this.props;
        const siteCode = this.props.ApplicationModel.siteCode;
        return (
            <>
                {this.canonical()}
                {isMainSiteCode(siteCode) && <div></div>}
                <HeroBannerContainer h1Banner={seoData && seoData.h1} />
                <WithSeoText seoData={seoData} text={text}>
                    <TariffsContainer isMainPage={true} />
                    {currentRegion && (
                        <Container>
                            <OneClick />
                        </Container>
                    )}
                    <TopProviderContainer />
                    {!windowSizes.xs && <RatingTableContainer />}
                    <ReviewsContainer />
                    <Container>
                        <DeclinationContainerNew>
                            <Districts />
                        </DeclinationContainerNew>
                    </Container>
                </WithSeoText>
            </>
        );
    }
}
